/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, $Sprite, ExtendSpriteProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {Texture} from 'pixi.js';

export type $HorizontalSeparatorProps = ExtendSpriteProps<{
    lineWidth: number;
    lineThickness?: number;
    lineColor?: number;
    lineAlpha?: number;
    visible?: boolean;
}>;

export const $HorizontalSeparator: FC<$HorizontalSeparatorProps> = (props) => {
    const {lineWidth, lineThickness, lineColor, lineAlpha} = props;

    const color = getProp(lineColor) || 0xffffff;
    const alpha = getProp(lineAlpha) || 1;
    const thickness = getProp(lineThickness) || 4;

    return <$Sprite
        {...props}
        name='HorizontalSeparator'
        texture={Texture.WHITE}
        anchor={0.5}
        width={lineWidth}
        height={thickness}
        alpha={alpha}
        tint={color}
    />
};